import { render, staticRenderFns } from "./GolfParkImages.vue?vue&type=template&id=9d28a3b6&scoped=true"
import script from "./GolfParkImages.vue?vue&type=script&lang=js"
export * from "./GolfParkImages.vue?vue&type=script&lang=js"
import style0 from "./GolfParkImages.vue?vue&type=style&index=0&id=9d28a3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d28a3b6",
  null
  
)

export default component.exports